module.exports = __webpack_public_path__ + "img/beachvolleyball.69cd715e.svg";